<mat-toolbar class="app-header">
  <div class="header-content">
    <div class="header-left">
      @if (showBackButton) {
        <button mat-icon-button (click)="goBack()" class="back-button" matTooltip="Back to dashboard">
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <a class="brand" (click)="goBack()">
        <span class="brand-mark">FC</span>
        <span class="brand-name">Transfer</span>
      </a>
      @if (sectionName) {
        <mat-icon class="crumb-sep">chevron_right</mat-icon>
        <h1 class="section-name">{{ sectionName }}</h1>
      }
      <ng-content select="[headerLeft]"></ng-content>
    </div>
    <div class="header-actions">
      <ng-content></ng-content>
    </div>
  </div>
</mat-toolbar>
